import { render, staticRenderFns } from "./ConfettiLoader.vue?vue&type=template&id=7d40ab81"
import script from "./ConfettiLoader.vue?vue&type=script&lang=ts"
export * from "./ConfettiLoader.vue?vue&type=script&lang=ts"
import style0 from "./ConfettiLoader.vue?vue&type=style&index=0&id=7d40ab81&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports